var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-p"},[(!_vm.isLoading)?_c('EmployeeCardInfo',{attrs:{"employeeData":_vm.employee}}):_vm._e(),_c('EmployeeDataTabs'),_c('router-view',{staticClass:"custom-tab-outer-content",attrs:{"employeeData":_vm.employee}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }